define('lightbox',[
  "jquery",
  "text!_lightbox.html"
], function($, template) {

  //do not run on mobile
  if (window.matchMedia && window.matchMedia("(max-width: 480px)").matches) return;

  var lightbox = $(template);
  var img = lightbox.find("img").get(0); //raw DOM elements
  var caption = lightbox.find(".lb-caption").get(0);
  var credit = lightbox.find(".lb-credit").get(0);
  lightbox.appendTo(document.body);

  $(document.body).on("click", "[lightbox]", function() {
    img.src = this.src;
    var $this = $(this);
    caption.innerHTML = $this.siblings(".caption").html();
    credit.innerHTML = $this.siblings(".credit").html();
    lightbox.addClass("show fade");
    //trigger fade on next tick
    setTimeout(function() {
      lightbox.removeClass("fade");
    });
  });

  lightbox.on("click", function() {
    lightbox.removeClass("show");
  });

});
